import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";
import {
  RequestSetCommentFeedbackDto,
  RequestSetCommentTaskDto,
  RequestSetFeedbackDto,
  RequestSetFeedbackTaskDto,
  RequestSetStatusTaskDto,
  RequestSetTaskDto,
  ResponseGetFeedbackDto,
  ResponseGetTaskDto,
  ResponseGetTaskMembersDto,
  ResponseSetCommentFeedbackDto,
  ResponseSetCommentTaskDto,
  ResponseSetFeedbackTaskDto,
  ResponseSetStatusTaskDto,
  ResponseSetTaskDto,
} from "../dto/task-feedback.dto";

@Injectable()
export class TaskFeedbackApi {

  private readonly service: string = 'attendance';
  private readonly model: string = 'taskFeedback';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getTask(limit: string | number, page: string | number, isStatus: boolean | string, type: string): Observable<ResponseGetTaskDto> {
    const method: string = 'GET';
    const func: string = 'getTask';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;
    if (typeof isStatus !== 'undefined' && isStatus !== null) urlParams.isStatus = isStatus;
    if (typeof type !== 'undefined' && type !== null) urlParams.type = type;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetTaskDto>(method, url, func, params, body);
  }

  public getFeedback(limit: string | number, page: string | number, type: string): Observable<ResponseGetFeedbackDto> {
    const method: string = 'GET';
    const func: string = 'getFeedback';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;
    if (typeof type !== 'undefined' && type !== null) urlParams.type = type;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetFeedbackDto>(method, url, func, params, body);
  }

  public setTask(payload: RequestSetTaskDto): Observable<ResponseSetTaskDto> {
    const method: string = 'POST';
    const func: string = 'setTask';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSetTaskDto>(method, url, params, urlParams, body);
  }

  public setStatusTask(payload: RequestSetStatusTaskDto): Observable<ResponseSetStatusTaskDto> {
    const method: string = 'POST';
    const func: string = 'setStatusTask';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSetStatusTaskDto>(method, url, params, urlParams, body);
  }

  public setCommentTask(payload: RequestSetCommentTaskDto): Observable<ResponseSetCommentTaskDto> {
    const method: string = 'POST';
    const func: string = 'setCommentTask';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSetCommentTaskDto>(method, url, params, urlParams, body);
  }

  public getTaskMembers(limit: string | number, page: string | number, filter: string): Observable<ResponseGetTaskMembersDto> {
    const method: string = 'GET';
    const func: string = 'getTaskMembers';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;
    if (typeof filter !== 'undefined' && filter !== null) urlParams.filter = filter;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetTaskMembersDto>(method, url, func, params, body);
  }

  public setFeedback(payload: RequestSetFeedbackDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'setFeedback';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public setCommentFeedback(payload: RequestSetCommentFeedbackDto): Observable<ResponseSetCommentFeedbackDto> {
    const method: string = 'POST';
    const func: string = 'setCommentFeedback';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSetCommentFeedbackDto>(method, url, params, urlParams, body);
  }

  public setFeedbackTask(payload: RequestSetFeedbackTaskDto): Observable<ResponseSetFeedbackTaskDto> {
    const method: string = 'POST';
    const func: string = 'setFeedbackTask';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSetFeedbackTaskDto>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-all-in-one/services/task-feedback.api.ts